import { create } from 'zustand';

interface ConsentStore {
  tosAccepted: boolean;
  aiDisclosureAccepted: boolean;
  resolved: boolean;

  // Actions
  setConsent: (partial: { tosAccepted?: boolean; aiDisclosureAccepted?: boolean; resolved?: boolean }) => void;
}

export const useConsentStore = create<ConsentStore>((set) => ({
  tosAccepted: true, // optimistic default
  aiDisclosureAccepted: true, // optimistic default
  resolved: false,

  setConsent: (partial) => set(partial),
}));
